import { TemplatesService } from "./lib/services/templates_service";

export type  {
    ITemplate,
    ITemplateComponent,
    IHistoryRecord,
    IFileSource,
    ITemplateTextComponent,
    ITemplateInputComponent,
    ITemplateMoneyComponent,
    ITemplateCheckboxComponent,
    ITemplateRadioComponent,
    ITemplateSelectComponent,
    ITemplateInputWithSelectComponent,
    ITemplateTableComponent,
    ITemplateMultilineComponent,
    ITemplateDateInputComponent,
    ITemplateFileComponent,
    ITemplateHrPersonComponent,
    ITemplateUuidComponent,
    ITemplateProcureComponent,
    ITemplateBarcodeComponent,
    ITemplateAutonumberComponent,
    IAutonumberCounter,
    IAutonumberCounterSaveRequest,
    IAutonumberCounterFilters,
    AutonumberCounterLoadError,
    ITemplateCounterpartyComponent,
    ICommonTemplateComponentProps,
    ITemplateLanguageComponent,
    ITemplateExternalFormComponent,
    ITemplateYandexComponent,
    TLegalCompaniesBlackListByKey,
    ITagSelectComponent,
    ITemplatePdfPasswordComponent,
    IVisibilityTemplateComponentProps,
    ITemplateMassGenerationComponent,
    ITemplateSaveAndTicketComponent,
    ITemplateSaveToExistingTicketComponent,
    ITemplateTrackerIntegrationComponent,
    IFieldList,
    IBusinessGroup,
    IOrganization,
    IOrgBankDetail,
    ILegalBankDetail,
    IBankDetail,
    MergeDocTypes,
    TicketField
} from "./lib/types/template_service_types";
export {
    FilterLogic,
    FilterOperator,
    defaultListFilter,
    defaultBankDetailsFilter,
} from "./lib/types/legal_list_filter";
export type {
    ILegalListFilter,
    ILegalListFilterRow,
    FilterLogicType,
    FilterOperatorType,
} from "./lib/types/legal_list_filter";
export { ComponentTypes } from "./lib/const/componentTypes";
export { BarcodeTypes, barcodeTypeLabels } from "./lib/const/barcodeTypes";
export { YandexListTypes } from "./lib/const/yandexListTypes";
export { radioDirectionTypes } from "./lib/const/radioDirectionTypes";
export { externalFormProtectTypes } from "./lib/const/externalFormProtectTypes";
export { cleanupTemplateComponents, addTemplateComponentId, stringToWysiwygSettings } from "./lib/utils/template-components";
export { isTemplateFieldVisible } from "./lib/utils/field-visibility";
export type { IFieldVisibilityContext } from "./lib/utils/field-visibility";

export const templatesService = new TemplatesService();
